// extracted by mini-css-extract-plugin
export default {"modal-actions":"OnboardingModalActions--modal-actions--twMXk","modalActions":"OnboardingModalActions--modal-actions--twMXk"};